import { format } from 'date-fns'
import formatDistance from 'date-fns/formatDistance'
import differenceInYears from 'date-fns/differenceInYears'
import setHours from 'date-fns/setHours'
import setMinutes from 'date-fns/setMinutes'
import setSeconds from 'date-fns/setSeconds'
import setMilliseconds from 'date-fns/setMilliseconds'
import toDate from 'date-fns/toDate'

// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
// displayDateFormat and displayDateTimeFormat2 - Do Not Change (Its tied to backend passing format)
export const displayDateFormat = 'dd/MM/yyyy'
export const displayDateFormat2 = 'MMM dd, yyyy'
export const displayDateTimeFormat = 'MMM dd, yyyy - h:mm a'
export const displayDateTimeFormat2 = 'dd/MM/yyyy - h:mm a'
export const displayTimeFormat = 'HH:mm'
export const serverTimeFormat = 'yyyy-MM-dd'

export const formatDisplayDate = (date) => {
  try {
    if (date) {
      return format(date, displayDateFormat)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatDisplayDate2 = (date) => {
  try {
    if (date) {
      return format(date, displayDateFormat2)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatDisplayDateTime = (datetime) => {
  try {
    if (datetime) {
      return format(datetime, displayDateTimeFormat)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatDisplayDateTime2 = (datetime) => {
  try {
    if (datetime) {
      return format(datetime, displayDateTimeFormat2)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatDisplayTime = (datetime) => {
  try {
    if (datetime) {
      return format(datetime, displayTimeFormat)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatDisplayTimeDistance = (datetime) => {
  try {
    if (datetime) {
      return formatDistance(new Date(), datetime)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const formatServerTimeFormat = (datetime) => {
  // This is to format datetime to server (api) recognised format (to remove timezone formatting)
  // This is to resolve date before 1981 whereby singapore changed timezone to align to hk timezone (by adding 30mins)
  try {
    if (datetime) {
      return format(toDate(datetime), serverTimeFormat)
    }
  } catch (err) {
    console.log(err)
  }
  return ''
}

export const yearDiff = (date1, date2) => {
  try {
    const date1Eff = removeTime(date1)
    const date2Eff = removeTime(date2)
    return differenceInYears(date1Eff, date2Eff)
  } catch (err) {
    console.log(err)
  }
  return undefined
}

export const removeTime = (datetime) => {
  let result = toDate(datetime)
  if (!checkValidDate(result)) {
    result = new Date(datetime)
  }
  result = setHours(result, 0)
  result = setMinutes(result, 0)
  result = setSeconds(result, 0)
  result = setMilliseconds(result, 0)
  return result
}

export const setEndTime = (datetime) => {
  let result = toDate(datetime)
  if (!checkValidDate(result)) {
    result = new Date(datetime)
  }
  result = setHours(result, 23)
  result = setMinutes(result, 59)
  result = setSeconds(result, 59)
  result = setMilliseconds(result, 999)
  return result
}

export const checkValidDate = (d) => {
  return d instanceof Date && !isNaN(d)
}

export const removeFormatDate = (date) => {
  if (date === null) {
    return null
  } else if (date === undefined) {
    return null
  } else if (date === '') {
    return null
  } else {
    var dateString = date
    var dateParts = dateString.split('/')
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
  }
}
